module.exports = __webpack_public_path__ + "static/media/autosicura.5287a325.png";